import { render, staticRenderFns } from "./ECommerceSelection.vue?vue&type=template&id=c4fe8f94&scoped=true&"
import script from "./ECommerceSelection.vue?vue&type=script&lang=js&"
export * from "./ECommerceSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4fe8f94",
  null
  
)

export default component.exports